import { TrendingUp, TrendingDown } from 'lucide-react'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/Card'
import { formatCurrency, formatNumber, formatPercentage } from '@/utils/formatters'
import { cn } from '@/utils/cn'

export function StatCard({ 
  title, 
  value, 
  change, 
  changeType = 'number', 
  trend = 'up',
  icon: Icon,
  format = 'number',
  className = '',
  ...props 
}) {
  const formatValue = (val) => {
    switch (format) {
      case 'currency':
        return formatCurrency(val)
      case 'percentage':
        return formatPercentage(val / 100)
      case 'number':
      default:
        return formatNumber(val)
    }
  }

  const formatChange = (val) => {
    switch (changeType) {
      case 'currency':
        return formatCurrency(val)
      case 'percentage':
        return formatPercentage(Math.abs(val) / 100)
      case 'number':
      default:
        return formatNumber(Math.abs(val))
    }
  }

  const isPositive = change > 0
  const TrendIcon = isPositive ? TrendingUp : TrendingDown

  return (
    <Card className={cn('hover:shadow-md transition-shadow', className)} {...props}>
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium text-muted-foreground">
          {title}
        </CardTitle>
        {Icon && <Icon className="h-4 w-4 text-muted-foreground" />}
      </CardHeader>
      <CardContent>
        <div className="text-2xl font-bold">{formatValue(value)}</div>
        {change !== undefined && (
          <div className="flex items-center text-xs text-muted-foreground mt-1">
            <TrendIcon className={cn(
              'h-3 w-3 mr-1',
              isPositive ? 'text-success-600' : 'text-danger-600'
            )} />
            <span className={cn(
              isPositive ? 'text-success-600' : 'text-danger-600'
            )}>
              {isPositive ? '+' : ''}{formatChange(change)}
            </span>
            <span className="ml-1">from last month</span>
          </div>
        )}
      </CardContent>
    </Card>
  )
}